var exports = {
  "CX": "x31de4314--1b6cc3--onboarding-anchor",
  "YP": "x31de4314--1b6cc3--onboarding-content",
  "lQ": "x31de4314--1b6cc3--onboarding-flight-content",
};

module.exports = exports;
